// extracted by mini-css-extract-plugin
export default {"modalOverlay":"lC-z","modalContent":"mC-z","header":"nC-z","close":"oC-z"};